/**
 * Stamp optionId onto overlay operation variables (sibling of `input`, not
 * nested inside live mutation inputs). Overlay path only.
 */
export const withOptionOnInput = <T extends Record<string, unknown>>(
  variables: T,
  optionId: string
): T & { optionId: string } => ({
  ...variables,
  optionId,
});
